import { useContext, useEffect, useState } from "react";
import { RolesContext } from "../context/User";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logger from "./logger";

export const useErrValidate = () => {
  const [errValidation, setErr] = useState(true);
  const navigate = useNavigate();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  const validationPage = (inputdata) => {
    async function fetchData() {
      try {
        const response = await axios.get(`/signIn/111`, {
          withCredentials: true,
        });

        if (
          response.status == 200 &&
          response.data.msg == "user is already sign in"
        ) {
          const response_data = response.data;
          dispatchroles({
            type: "USER",
            payload: {
              value: response_data,
            },
          });
        }
      } catch (error) {
        if (error.response.status == 404) {
          dispatchroles({
            type: "USER",
            payload: {
              value: {
                customers: [],
                roles: [],
              },
            },
          });
          navigate(`/`);
        }
        logger.error(error);
      }
    }
    fetchData();
    if (stateroles.userId) {
      // Special validation for linkopeninvoice - requires priorityCode "A"
      if (inputdata === "linkopeninvoice") {
        if (stateroles.priorityCode === "A") {
          setErr(true);
        } else {
          setErr(false);
          navigate(`/errormessage`);
        }
      }
      // Special validation for nursinghome - priorityCode "B" users can ONLY access nursinghome or portal
      else if (
        (stateroles.roles.includes("admin") ||
          stateroles.roles.includes("nursinghome")) &&
        stateroles.priorityCode === "B"
      ) {
        if (inputdata === "nursinghome" || inputdata === "portal") {
          setErr(true);
        } else {
          setErr(false);
          navigate(`/portal`);
        }
      }
      // Special validation for hospital - priorityCode "D" users can ONLY access chemo or portal
      else if (
        (stateroles.roles.includes("admin") ||
          stateroles.roles.includes("hospital")) &&
        stateroles.priorityCode === "D"
      ) {
        if (inputdata === "chemo" || inputdata === "portal") {
          setErr(true);
        } else {
          setErr(false);
          navigate(`/portal`);
        }
      }
      // General role validation for other pages
      else if (
        stateroles.roles.includes(inputdata) ||
        stateroles.roles.includes("admin") ||
        inputdata == "general"
      ) {
        setErr(true);
      } else if (!stateroles.roles.includes(inputdata)) {
        setErr(false);
        navigate(`/errormessage`);
      }
    }
  };

  return { validationPage };
};
